import type { RouteRecordRaw } from "vue-router"

export const organisationRoutes: RouteRecordRaw[] = [
    {
        path: "/care",
        component: () => import("@/layouts/AuthLayout.vue"),
        meta: { guest: true },
        children: [
            {
                path: "login",
                name: "care-login",
                component: () => import("@/pages/care/Login.vue"),
                meta: { title: "Login" },
            },
            {
                path: "register",
                name: "care-register",
                component: () => import("@/pages/care/Register.vue"),
                meta: { title: "Register" },
            },
        ],
    },
    {
        path: "/care/auth/google/callback",
        name: "care-google-callback",
        component: () => import("@/pages/care/GoogleCallback.vue"),
        meta: { skipAuthInit: true, skipVerification: true },
    },
    {
        path: "/care/select-org",
        name: "care-select-org",
        component: () => import("@/pages/care/SelectOrganisation.vue"),
        meta: { requiresAuth: true, requiresRole: ["organisation_owner", "organisation_admin"], title: "Select Organisation" },
    },
    {
        path: "/care",
        component: () => import("@/layouts/care/CareLayout.vue"),
        meta: { requiresAuth: true, requiresRole: ["organisation_owner", "organisation_admin"] },
        children: [
            {
                path: "notifications",
                name: "care-notifications",
                component: () => import("@/pages/care/Notifications.vue"),
                meta: { title: "Notifications" },
            },
            {
                path: ":pathMatch(.*)*",
                name: "care-base-not-found",
                component: () => import("@/pages/care/NotFound.vue"),
                meta: { title: "Not Found" },
            },
        ],
    },
    {
        path: "/care/:org_no",
        component: () => import("@/layouts/care/CareLayout.vue"),
        meta: { requiresAuth: true, requiresRole: ["organisation_owner", "organisation_admin"], requiresOrgSelection: true },
        children: [
            {
                path: "account",
                name: "care-account",
                component: () => import("@/pages/care/Account.vue"),
                meta: { skipVerification: true, title: "Account" },
            },
            {
                path: "help",
                name: "care-help",
                component: () => import("@/pages/care/Help.vue"),
                meta: { skipVerification: true, title: "Help" },
            },
            {
                path: "dashboard",
                name: "care-dashboard",
                component: () => import("@/pages/care/Dashboard.vue"),
                meta: { title: "Dashboard" },
            },
            {
                path: "centres",
                name: "care-centre",
                component: () => import("@/pages/care/CentreIndex.vue"),
                meta: { title: "Centres" },
            },
            {
                path: "centres/create",
                name: "care-centre-create",
                component: () => import("@/pages/care/CentreCreate.vue"),
                meta: { title: "Add Centre" },
            },
            {
                path: "centres/:id",
                name: "care-centre-show",
                component: () => import("@/pages/care/CentreShow.vue"),
            },
            {
                path: "centres/:id/edit",
                name: "care-centre-edit",
                component: () => import("@/pages/care/CentreEdit.vue"),
                meta: { title: "Edit Centre" },
            },
            {
                path: "find-talent",
                name: "care-find-talent",
                component: () => import("@/pages/care/find-talent/FindTalent.vue"),
                meta: { title: "Find Talent" },
            },
            // My Connection is gone: Unlock Talent replaces it. The old links
            // land on Find Talent so bookmarks and emails do not 404.
            {
                path: "talent-connection",
                redirect: { name: "care-find-talent" },
            },
            {
                path: "connections",
                redirect: { name: "care-find-talent" },
            },
            {
                path: "customer-inquiry",
                name: "care-customer-inquiry",
                component: () => import("@/pages/care/CustomerInquiry.vue"),
                meta: { title: "Customer Inquiry" },
            },
            {
                path: "job-board",
                name: "care-job-board",
                component: () => import("@/pages/care/JobBoard.vue"),
                meta: { title: "Job Board", requiresJobBoard: true },
            },
            {
                path: "job-board/applicants",
                name: "care-job-applicants",
                component: () => import("@/pages/care/JobApplicants.vue"),
                meta: { title: "Job Applicants" },
            },
            {
                path: "plan-pricing",
                name: "care-plan-pricing",
                component: () => import("@/pages/care/PlanPricingPage.vue"),
                meta: { title: "Plan & Pricing", requiresCredits: true },
            },
            {
                path: "usage-history",
                name: "care-usage-history",
                component: () => import("@/pages/care/UsageHistory.vue"),
                meta: { title: "Usage History", requiresCredits: true },
            },
            {
                // Legacy paths (old /billing links + gateway return URLs) land on Usage
                // History; keep the query so the payment-return toast still fires.
                path: "billing",
                redirect: (to) => ({ name: "care-usage-history", query: to.query }),
            },
            {
                path: "billing/checkout",
                redirect: (to) => ({ name: "care-plan-pricing", query: to.query }),
            },
            {
                path: ":pathMatch(.*)*",
                name: "care-not-found",
                component: () => import("@/pages/care/NotFound.vue"),
                meta: { title: "Not Found" },
            },
        ],
    },
]
